module.exports = __webpack_public_path__ + "img/2.dec91fda.png";